<template>
  <div id="dlnkcalendar-sessions-content">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <!-- Button trigger modal -->
    <button type="submit" @click="show_modal()"
            class="btn btn-block btn-primary btn-resa mb-2">
      <i aria-hidden="true" class="fa fa-calendar"></i>&nbsp;Je&nbsp;participe&nbsp;!
    </button>

    <!-- Modal -->
    <div class="modal fade" :id="'book-session-modal_' + event_id" tabindex="-1" aria-labelledby="book-session-modalLabel"
         aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="book-session-modalLabel">{{event.event_name}} - Réservation</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <div class="alert alert-info">
              Cliquer sur les sessions que vous désirez reserver.
              <br>
              <span class="text-success">Vert, votre réservation est enregistrée</span>
              <br>
              <span class="text-info">Bleu, la session est disonible</span>
            </div>

            <div class="mt-2" id="reservation-calendar">
              <FullCalendar ref="reservationCalendar" :options="calendar_options"/>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
            <button type="button" class="btn btn-primary">Enregistrer</button>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import frLocale from '@fullcalendar/core/locales/fr';
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";

export default {

  components: {
    FullCalendar
  },

  props: [
      'event_id',
  ],

  data: function () {
    return {
      event: Object,
      message: "",
      message_type: "",
      calendar_options: {
        events: [],
        editable: false,
        navLinks: true,
        timeZone: 'Europe/Paris',
        locale: frLocale,
        initialDate: new Date(),
        initialView: 'dayGridMonth',
        eventDisplay: 'block',
        plugins: [ dayGridPlugin, interactionPlugin, timeGridPlugin ],
        eventClick: this.eventClick,
      }
    }
  },

  mounted() {
    this.message = ""
    this.message_type = ""
  },

  watch: {},

  methods: {

    show_modal: function () {
      this.get_data()
      $('#book-session-modal_' + this.event_id).modal('show')

      let calendar = this.$refs.reservationCalendar.getApi()
      calendar.setOption('contentHeight', 'auto');
    },

    eventClick: async function (info) {
      const _this = this
      const event = info.event
      const session_date = event.extendedProps['start_fr']

      if(event.extendedProps['user_has_reservation']) {

        // TODO - gestion multi reservation
        // On supprime la reservation
        const reservation_id = event.extendedProps['reservation_id']

        let [secure_key, customer_id, api_url, customer] = await get_token_2()
        api_url += `/event_reservations/${reservation_id}.json`
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        axios({
          method: 'delete',
          url: api_url
        })
            .then(function (response) {
              const date = response.data.date

              _this.message = 'Votre réservation a été supprimé'
              _this.message_type = "alert-success"
              _this.get_data()
            })
            .catch(function (error) {
            })
      }
      else {

        const session_id = event.id

        if (_this.event.multi_registration) {
          let redirect_url = '/module/dlnkcalendar/multi_registration'
          redirect_url += `?event_id=${_this.event_id}`
          redirect_url += `&session_id=${session_id}`

          window.location.href = redirect_url
        }

        // On effectue la reservation
        let [secure_key, customer_id, api_url, customer] = await get_token_2()
        api_url += "/event_reservations.json"
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        let formData = new FormData();
        formData.append('event_reservation[id_event]', _this.event_id)
        formData.append('event_reservation[id_user]', customer_id)
        formData.append('event_reservation[reservation_quantity]', 1)
        formData.append('event_reservation[reservation_lastname]', customer.lastname)
        formData.append('event_reservation[reservation_firstname]', customer.firstname)
        formData.append('event_reservation[phone]', customer.mobile_phone)
        formData.append('event_reservation[reservation_email]', customer.email)
        formData.append('event_reservation[id_session]', session_id)

        axios({
          method: 'post',
          url: api_url,
          data: formData,
        })
            .then(function (response) {
              const date = response.data.date

              _this.message = 'Votre réservation pour le ' + date + ' est enregistrée'
              _this.message_type = "alert-success"
              _this.get_data()
            })
            .catch(function (error) {
              const field = Object.keys(error.response.data)[0]
              const error_message = error.response.data[field][0]
              _this.message = error_message;
              _this.message_type = "alert-danger";
            })
      }

      return true

    },

    close_message: function () {
      this.message = "";
      this.message_type = "";
    },

    get_data: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += "/events/" + _this.event_id + ".json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id


      axios.get(api_url)
          .then(function (response) {
            _this.event = response.data
            _this.calendar_options.events =  _this.event.sessions
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },
  }
}

</script>
